import React, {Fragment} from 'react';
import {Video, Transformation} from 'cloudinary-react';
import { Container, Row, Col , Image } from 'react-bootstrap';
import styles from './W.css'
import GifPlayer from 'react-gif-player';

const W = () => {
    return(
        <Fragment>
<hr
        style={{
          color: 'white',
          backgroundColor:'hsl(244, 95%, 37%)',
            height: 100,
            borderColor : 'darkred'
        }}
    />
    <br />
<Container>
  <Row >
    <Col xs={6} md={4} id='pic'>
    <span style={{flex: 1,
    width: null,
    height: null,
    resizeMode: 'contain'}}>
     <a href={"https://solmazsm.github.io/weather/"}> <Image src="images/weather.PNG" thumbnail  fluid /></a></span>
    </Col>
    
    <Col xs={6} md={4} id='text'>
    
    <span style={{color:'hsl(244, 95%, 37%)', fontStyle:'revert', fontSize:'18px'}}>
      
      Weather App UI/UX </span><br />
      <a href={"https://solmazsm.github.io/weather/"}>
    Produced an application using REACT request user three pieces of information: user's name, last name and zip code 
    and provide with location specific information such as weather and zip code and greeting. 
    </a></Col>
    <Col xs={6} md={4}></Col>
  </Row>
  <br />
  <Row >
    <Col xs={6} md={4}>
    <a href="http://535fall2018solmazmonir.blogspot.com/">
      <Image src="images/datacenter.PNG" thumbnail  bsPrefix  /></a>
    </Col>
    
    <Col xs={6} md={4} id='text1'>
    <span style={{color:'hsl(244, 95%, 37%)', fontStyle:'revert', fontSize:'18px'}}>
Data Architecture</span> <br />
<a href="http://535fall2018solmazmonir.blogspot.com/">
    Led a group project. Worked together on a project raised enthusiasm and finally, team could build a data center for Alpha Vertical, Inc with Cisco 
    Nexus 5500 switches, Virtual port-channel technology, and operating firewall for security
   </a> </Col>
    <Col xs={6} md={4}></Col>
  </Row>
  <br />
  <Row >
    <Col xs={6} md={4}>
   
      <Image src="images/insu.PNG"thumbnail  bsPrefix  />
    </Col>
    
    <Col xs={6} md={4} id='text2'>
    <span style={{color:'hsl(244, 95%, 37%)', fontStyle:'revert', fontSize:'18px'}}>Auto Insurance </span> <br />
    Developed database and UI for an insurance company to add, remove, 
    update, and modify claims (with photos) in Java and operating MySQL.
    </Col>
    <Col xs={6} md={4}></Col>
  </Row>
  <br />
  <Row >
    <Col xs={6} md={4}>
   
      <Image src="images/chart.PNG"thumbnail  bsPrefix  />
    </Col>
    
    <Col xs={6} md={4} id='text3'>
    <span style={{color:'hsl(244, 95%, 37%)', fontStyle:'revert', fontSize:'18px'}}>Chart</span> <br />
    Developed database and UI for an insurance company to add, remove, 
    update, and modify claims (with photos) in Java and operating MySQL.
    </Col>
    <Col xs={6} md={4}></Col>
  </Row>
  <br />
  <Row >
    <Col xs={6} md={4}>
   
      <Image src="images/sql.PNG"thumbnail  bsPrefix  />
    </Col>
    
    <Col xs={6} md={4} id='text4'>
    <span style={{color:'hsl(244, 95%, 37%)', fontStyle:'revert', fontSize:'18px'}}>Database</span> <br />
    Developed database and UI for an insurance company to add, remove, 
    update, and modify claims (with photos) in Java and operating MySQL.
    </Col>
    <Col xs={6} md={4}></Col>
  </Row>
  <br />
  <Row >
    <Col xs={6} md={4}>
   
      <Image src="images/ThesisSM.png"thumbnail  bsPrefix  />
    </Col>
    
    <Col xs={6} md={4} id='text5'>
    <span style={{color:'hsl(244, 95%, 37%)', fontStyle:'revert', fontSize:'18px'}}>
    Master's Thesis </span><br />
    Provided a model for optimizing customer value at contact center 
    </Col>
    <Col xs={6} md={4}></Col>
  </Row>
  <br /><br /><br />
  <Row >
    <Col xs={6} md={4}>
   
      <Image src="https://www.docker.com/sites/default/files/d8/2019-07/horizontal-logo-monochromatic-white.png"thumbnail  bsPrefix  />
    </Col>
    
    <Col xs={6} md={4} id='text5'>
    <span style={{color:'hsl(244, 95%, 37%)', fontStyle:'revert', fontSize:'18px'}}>
    Docker Container  </span><br />
    Researched and wrote a paper about docker and how it's had a higher performance rather than to another virtualization. 
    </Col>
    <Col xs={6} md={4}></Col>
  </Row>
  <br /><br /><br />
  <Row >
    <Col xs={6} md={4}>
   
     <img src={"test.gif"} alt="GIF" />
      
      
    </Col>
    
    <Col xs={6} md={4} id='text5'>
    <span style={{color:'hsl(244, 95%, 37%)', fontStyle:'revert', fontSize:'18px'}}>
    PROGRAMMING PROJECT | Dynamic Website </span><br />
    <a href={"https://github.com/tranrandy23/SierraRecruitment/tree/solmaz"}>
    Led a group project created by Java and Angular. Application has three parts and developed login and CRUD backend and frontend. Frontend was written by Angular and bootstrap and backend was written by JAVA Spring Boot, MySQL. 
  </a>
    </Col>
    <Col xs={6} md={4}></Col>
  </Row>
  <br />
  <br /><br /><br />
  <Row >
    <Col xs={6} md={4}>
    <a href={"https://github.com/tranrandy23/SierraRecruitment/tree/solmaz"}>
    <video width="170" height="170" controls   
          
          loop="true"
          src="videos/pre.mp4" type="video/mp4" />
          <Transformation crop="pad" height="300" width="380" quality="70" duration="10"  /></a>
    </Col>
    
    
  <Col xs={6} md={4} id='text6'>
    <span style={{color:'hsl(244, 95%, 37%)', fontStyle:'revert', fontSize:'18px'}}>
    PROGRAMMING PROJECT | Dynamic Website | Video</span><br />
    <a href={"https://github.com/tranrandy23/SierraRecruitment/tree/solmaz"}>
    Led a group project created by Java and Angular. Application has three parts and developed login and CRUD backend and frontend. Frontend was written by Angular and bootstrap and backend was written by JAVA Spring Boot, MySQL. 
  </a>
    </Col>
    <Col xs={6} md={4}></Col>
  </Row>
  <br />
</Container>
<br /><br /><hr
        style={{
          color: 'white',
          backgroundColor:'hsl(244, 95%, 37%)',
            height: 300,
            borderColor : 'darkred'
        }}
    />
<style>{'body { background-color: rgb(251, 252, 247);}'}</style>
        </Fragment>
    );
}


export default W;